import EditRemitDetails from './EditRemitDetails';

export default EditRemitDetails;
